const RefineResultsFooter = () => {
  return (
    <>
      <h5>WHY THIS MATTERS</h5>
      <p>
        Our algorithms will help you to find the Trials that fit your criteria. You will be asked a series of questions to help you find the
        best trials.
      </p>
    </>
  );
};

export default RefineResultsFooter;
